/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DisputeStatus = {
    OPEN: 'OPEN',
    RESOLVED: 'RESOLVED'
} as const;
export type DisputeStatus = typeof DisputeStatus[keyof typeof DisputeStatus];


export function instanceOfDisputeStatus(value: any): boolean {
    for (const key in DisputeStatus) {
        if (Object.prototype.hasOwnProperty.call(DisputeStatus, key)) {
            if (DisputeStatus[key as keyof typeof DisputeStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DisputeStatusFromJSON(json: any): DisputeStatus {
    return DisputeStatusFromJSONTyped(json, false);
}

export function DisputeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputeStatus {
    return json as DisputeStatus;
}

export function DisputeStatusToJSON(value?: DisputeStatus | null): any {
    return value as any;
}

export function DisputeStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): DisputeStatus {
    return value as DisputeStatus;
}

